// Netlify Identity (GoTrue) via the official widget. The widget owns the session;
// we only ask it for a fresh JWT before each API call.
import netlifyIdentity from "netlify-identity-widget";

export interface IdentityUser {
  email: string;
  user_metadata?: { full_name?: string };
}

export function initIdentity(onChange: (user: IdentityUser | null) => void) {
  netlifyIdentity.on("login", (u) => {
    onChange(u as IdentityUser);
    netlifyIdentity.close();
  });
  netlifyIdentity.on("logout", () => onChange(null));
  // The widget initialises itself as soon as the module is imported (and emits "init" before
  // we could subscribe); init() is then a no-op. The session is restored synchronously, so we
  // read the current user directly instead of waiting for an event that already fired.
  netlifyIdentity.init({ logo: false, namePlaceholder: "Full name (e.g. Scott Bergmann)" });
  onChange((netlifyIdentity.currentUser() as IdentityUser | null) ?? null);
}

export const openLogin = (tab: "login" | "signup" = "login") => netlifyIdentity.open(tab);
export const logout = () => netlifyIdentity.logout();

/** Returns a valid access token, refreshing it when it is about to expire. */
export async function accessToken(): Promise<string | null> {
  if (!netlifyIdentity.currentUser()) return null;
  try {
    return await netlifyIdentity.refresh();
  } catch {
    return null;
  }
}
